import 'babel-polyfill';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import moment from 'moment';
import trans from './trans';
import faker from './faker';
import Clipboard from 'v-clipboard';
import VueTheMask from 'vue-the-mask';
import VueAnalytics from 'vue-analytics';

// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';

import firebase, { auth } from './firebase';

// import 'roboto-fontface/css/roboto/roboto-fontface.css'
// import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css';

import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

import google from './google';
import InputFactory from './ui/InputFactory';
import Messages from './components/Messages';
import AppFooter from './components/AppFooter';
import MainNavbar from './components/MainNavbar';

import ServerSideIterator from './components/ServerSideIterator';
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition';
Vue.config.productionTip = false;
const slideFadeTransition = createSimpleTransition('slide-fade');

Vue.component('slide-fade', slideFadeTransition);
Vue.component('main-navbar', MainNavbar);
Vue.component('input-factory', InputFactory);
Vue.component('server-side-iterator', ServerSideIterator);
Vue.component('messages', Messages);
Vue.component('app-footer', AppFooter);
Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        if (vnode.context) vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

Vue.use(google, { key: process.env.VUE_APP_GOOGLE_API_KEY });
Vue.use(Clipboard);
Vue.use(VueTheMask);

Vue.prototype.trans = trans;
Vue.prototype.faker = faker;
Vue.prototype.url = (url) => window._API + '' + url;
Vue.prototype.todo = () =>
  window.alert('The current section is under development. Please try again later.');

moment().locale('en');
moment().utcOffset(60);
Vue.prototype.moment = (timestamp) =>
  moment(timestamp)
    .locale('en')
    .utcOffset(60)
    .fromNow();

// On the dev server, we can disable analytics.
if (process.env.NODE_ENV !== 'development') {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_FIREBASE_CONFIG_MEASUREMENTID,
    router,
  });
}

// if (process.env.NODE_ENV !== "development") {
// 	Sentry.init({
// 		dsn: 'https://8a46b0f6355e4a968541a625aa0ce65b@sentry.io/1767824',
// 		integrations: [
// 			new Integrations.Vue({
// 				Vue,
// 				attachProps: true
// 			})
// 		],
// 	});
// }

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  created() {
    store.dispatch('locale/setLocale');
  },
});

app.$mount('#app');

// window.app = app;

router.beforeEach((to, from, next) => {
  if (store.state.auth.authenticated) {
    let expires_at = store.state.auth.expires_at;
    let now = new Date();
    let diff = (expires_at - now) / 1000 / 60;
    if (diff < 5) {
      firebase
        .auth()
        .currentUser.getIdToken(true)
        .then((token) => {
          let updated_user = firebase.auth().currentUser;
          store.dispatch('auth/refresh', updated_user.toJSON());
          return next();
        })
        .catch(() => {
          return next();
        });
    } else {
      return next();
    }
  } else {
    return next();
  }
});
